import { render, staticRenderFns } from "./year.vue?vue&type=template&id=500f2990&scoped=true&"
import script from "./year.vue?vue&type=script&lang=js&"
export * from "./year.vue?vue&type=script&lang=js&"
import style0 from "./year.vue?vue&type=style&index=0&id=500f2990&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500f2990",
  null
  
)

export default component.exports